var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{staticClass:"light-blue darken-4",attrs:{"primary-title":""}},[_c('div',[_c('p',{staticClass:"display-1 bold white--text"},[_vm._v("Give Freedom Today!")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"subheading white--text",staticStyle:{"font-style":"italic"}},[_vm._v("“"+_vm._s(_vm.quote)+"”")])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"subheading white--text"},[_vm._v("~"+_vm._s(_vm.author))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e299a1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DonationCardTitle.vue
// module id = 591
// module chunks = 0